import styled from 'styled-components'
import { theme } from '../../../../../style/theme'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const OrderContainer = styled.div`
	color: ${colorTheme.PreviewOrderModal.text};
	height: 100%;
	overflow-y: auto;
	padding-right: 0.63em;
`
OrderContainer.displayName = 'OrderContainer'

export const OrderHeaderWrap = styled.div`
	display: flex;
	gap: 0.63em;
	flex-direction: column;
	margin-bottom: 1.25em;

	@media screen and (max-width: ${theme.point720}) {
		margin-bottom: 1.87em;
	}
`
OrderHeaderWrap.displayName = 'OrderHeaderWrap'

export const OrderCompanyTitle = styled.div`
	font-size: 1.25em;
	text-align: center;

	span {
		font-family: ${theme.fontRobotoMedium};
	}

	@media screen and (max-width: ${theme.point720}) {
		font-size: 1.125em;
	}
`
OrderCompanyTitle.displayName = 'OrderCompanyTitle'

export const OrderTitle = styled.div`
	font-size: 1.25em;
	text-align: left;

	&.center {
		text-align: center;
	}

	&.right {
		text-align: right;
	}

	&.bold {
		font-family: ${theme.fontRobotoMedium};

		> div {
			font-family: ${theme.fontRobotoMedium};
		}
	}
`
OrderTitle.displayName = 'OrderTitle'

export const OrderSubTitle = styled.div`
	font-size: 1em;
	text-align: left;

	> span {
		font-weight: 400;
	}

	&.center {
		text-align: center;
	}

	&.right {
		text-align: right;
	}

	&.bold {
		font-family: ${theme.fontRobotoMedium};
	}
`
OrderSubTitle.displayName = 'OrderSubTitle'

export const OrderText = styled.div`
	font-size: 0.88em;
	text-align: left;
`
OrderText.displayName = 'OrderText'

export const OrderRemark = styled.div`
	font-size: 1em;
	padding: 0.93em 0;
	font-style: italic;
	border-top: 1px dashed ${colorTheme.PreviewOrderModal.border};
	border-bottom: 1px dashed ${colorTheme.PreviewOrderModal.border};
`
OrderRemark.displayName = 'OrderRemark'

export const OrderProductRemark = styled.div`
	font-size: 1em;
	padding: 0.63em 0;
	font-style: italic;
	border-top: 1px dashed ${colorTheme.PreviewOrderModal.border};
	border-bottom: 1px dashed ${colorTheme.PreviewOrderModal.border};
`
OrderRemark.displayName = 'OrderRemark'

export const OrderProductsWrap = styled.div`
	margin-bottom: 0.93em;

	> div:last-child {
		border-bottom: 1px dashed ${colorTheme.PreviewOrderModal.border};
	}

	@media screen and (max-width: ${theme.point720}) {
		> div:last-child {
			border-bottom: 2px solid ${colorTheme.PreviewOrderModal.border};
		}
	}
`
OrderProductsWrap.displayName = 'OrderProductsWrap'

export const OrderProduct = styled.div`
	display: flex;
	gap: 0.93em;
	flex-direction: column;
	padding-bottom: 0.93em;
	border-bottom: 1px dashed ${colorTheme.PreviewOrderModal.borderProduct};
	margin-bottom: 0.93em;
`
OrderProduct.displayName = 'OrderProduct'

export const OrderMenuWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`
OrderMenuWrapper.displayName = 'OrderMenuWrapper'

export const OrderProductWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-left: 0.63em;
`
OrderProductWrapper.displayName = 'OrderProductWrapper'

export const OrderIngredients = styled.div`
	margin-left: 0.63em;
`
OrderIngredients.displayName = 'OrderIngredients'

export const OrderToppings = styled.div`
	display: flex;
	gap: 0.37em;
	flex-direction: column;
`
OrderToppings.displayName = 'OrderToppings'

export const OrderTopping = styled.div`
	display: flex;
	justify-content: space-between;
	margin-left: 1.25em;
`
OrderTopping.displayName = 'OrderTopping'

export const OrderCost = styled.div`
	display: flex;
	justify-content: space-between;

	&.cost {
		margin-top: 0.63em;
		text-transform: uppercase;
	}

	@media screen and (max-width: ${theme.point720}) {
		&.cost {
			margin-top: 0.32em;
		}
	}
`
OrderCost.displayName = 'OrderCost'

export const OrderDelivery = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.93em;
	padding-bottom: 0.93em;
	border-bottom: 1px dashed ${colorTheme.PreviewOrderModal.border};

	@media screen and (max-width: ${theme.point720}) {
		gap: 0.37em;
	}
`
OrderDelivery.displayName = 'OrderDelivery'

export const OrderTotalsWrap = styled.div`
	display: flex;
	gap: 0.93em;
	flex-direction: column;
`
OrderTotalsWrap.displayName = 'OrderTotalsWrap'

export const OrderTotalWrapper = styled.div`
	display: flex;
	gap: 0.37em;
	flex-direction: column;

	&.top {
		margin-top: -0.32em;
	}

	@media screen and (max-width: ${theme.point720}) {
		&.top {
			margin-top: -0.63em;
		}
	}
`
OrderTotalWrapper.displayName = 'OrderTotalWrapper'

export const OrderCount = styled.div`
	font-size: 1em;
	margin-top: 0.63em;
	margin-bottom: 1.87em;
	padding-bottom: 1.87em;
	border-bottom: 1px dashed ${colorTheme.PreviewOrderModal.borderCount};
	font-family: ${theme.fontRobotoMedium};

	> span {
		font-weight: 400;
	}
`
OrderCount.displayName = 'OrderCount'

export const OrderRate = styled.div`
	font-size: 1.07em;
	text-align: right;
	text-transform: uppercase;
`
OrderRate.displayName = 'OrderRate'

export const OrderGiftCouponTitle = styled.div`
	font-size: 1em;
	text-align: left;
	font-family: ${theme.fontRobotoBold};
`
OrderGiftCouponTitle.displayName = 'OrderGiftCouponTitle'

export const OrderGiftCouponWrap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.12em;
`
OrderGiftCouponWrap.displayName = 'OrderGiftCouponWrap'

export const OrderCountByCategory = styled.div`
	font-size: 1em;
	font-weight: 400;
	margin-top: 1.25em;
`
OrderCountByCategory.displayName = 'OrderCountByCategory'

export const OrderPagerCode = styled.div`
	color: ${colorTheme.PreviewOrderModal.text};
	text-align: center;
	font-family: ${theme.fontRobotoBold};
	font-size: 1.25em;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`
OrderPagerCode.displayName = 'OrderPagerCode'

export const OrderAbortWrap = styled.div`
	font-size: 1rem;
	display: flex;
	padding: 0.2em 0.93em;
	justify-content: center;
	align-items: center;
	gap: 0.63em;
	border-radius: 1.25em;
	background: ${colorTheme.PreviewOrderModal.abort.background};
	min-height: 2.07em;
	width: fit-content;
	margin: 0.63em auto;
`
OrderAbortWrap.displayName = 'OrderAbortWrap'

export const OrderAbortTitle = styled.div`
	color: ${colorTheme.PreviewOrderModal.abort.text};
	text-align: center;
	font-family: ${theme.fontRobotoBold};
	font-size: 1.25em;

	&.lf-uppercase {
		text-transform: uppercase;
	}

	&.regular {
		font-family: ${theme.fontRobotoRegular};
	}
`
OrderAbortTitle.displayName = 'OrderAbortTitle'

export const OrderHeaderRestaurantInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25em;

	@media screen and (max-width: ${theme.point720}) {
		align-items: center;
	}
`
OrderHeaderRestaurantInfo.displayName = 'OrderHeaderRestaurantInfo'

export const OrderHeaderRestaurant = styled.div`
	display: grid;
	grid-template-columns: 1fr max-content;
	justify-content: space-between;
	gap: 0.63em;
	padding-bottom: 1.25em;
	border-bottom: 1px dashed ${colorTheme.PreviewOrderModal.border};

	@media screen and (max-width: ${theme.point820}) {
		padding-bottom: 0.72em;
	}

	@media screen and (max-width: ${theme.point720}) {
		grid-template-columns: 1fr;
		justify-items: center;
		padding-bottom: 0.63em;
	}
`
OrderHeaderRestaurant.displayName = 'OrderHeaderRestaurant'
